import { ParameterRange, TablePercentageRow, TableRange } from "./../types/parameterRange.type";
import { TableParameterRange } from "@/types/parameterRange.type";
import { ValidationFilter_2 } from "./../types/estimation.type";

import { responseHandlerDefault } from "./../utils/handler.util";
import axios from "./api";
import { PaginationRequest } from "@/types/pagination.type";

const paramRangeRoute = "/parameter-range/";

export const getParameterRange = (
  samplingPoint?: number,
  parameter?: number
): Promise<TableParameterRange[]> => {
  const params: { samplingPoint?: number; parameter?: number } = { samplingPoint, parameter };

  return axios.get<TableParameterRange[]>(paramRangeRoute, { params }).then(responseHandlerDefault);
};

export const postParameterRange = (
  parameterRanges: ParameterRange[]
): Promise<TableParameterRange[]> => {
  return axios
    .post<ParameterRange[]>(paramRangeRoute, parameterRanges)
    .then(responseHandlerDefault);
};

export const calculateParameterRange = (
  filter: ValidationFilter_2
): Promise<{ tableRange: TableRange[]; graphProbability: number[] }> => {
  const params: PaginationRequest<ValidationFilter_2> = {};

  if (filter) {
    params.filter = filter;
  }
  return axios
    .post<any[]>(`${paramRangeRoute}calculate`, {
      params: { ...params },
    })
    .then(responseHandlerDefault);
};

export const calculateTmoaRange = (
  filter: ValidationFilter_2
): Promise<{ tableRange: TableRange[]; graphProbability: number[] }> => {
  const params: PaginationRequest<ValidationFilter_2> = {};

  if (filter) {
    params.filter = filter;
  }
  return axios
    .post<any[]>(`${paramRangeRoute}calculate-tmoa`, {
      params: { ...params },
    })
    .then(responseHandlerDefault);
};

// Calcular estadisticas por rango de horas
export const calculateHourlyData = (
  filter: ValidationFilter_2
): Promise<
  {
    tmoa: number;
    "00:00-08:00": number;
    "08:00-16:00": number;
    "16:00-00:00": number;
  }[]
> => {
  const params: PaginationRequest<ValidationFilter_2> = {};
  if (filter) params.filter = filter;

  return axios
    .post<any[]>(`${paramRangeRoute}calculate-hourly`, {
      params: { ...params },
    })
    .then(responseHandlerDefault);
};

//Calcular estadisticas por dia de la semana
export const calculateWeeklyData = (
  filter: ValidationFilter_2
): Promise<
  Array<{
    tmoa: number;
    lunes: number;
    martes: number;
    miércoles: number;
    jueves: number;
    viernes: number;
    sábado: number;
    domingo: number;
  }>
> => {
  const params: PaginationRequest<ValidationFilter_2> = {};
  if (filter) params.filter = filter;

  return axios
    .post<any[]>(`${paramRangeRoute}calculate-weekly`, {
      params: { ...params },
    })
    .then(responseHandlerDefault);
};

// Calcular estadisticas por rango de horas PARAM
export const calculateHourlyDataParam = (
  filter: ValidationFilter_2
): Promise<
  {
    id: number;
    nameRange: string;
    "00:00-08:00": number;
    "08:00-16:00": number;
    "16:00-00:00": number;
  }[]
> => {
  const params: PaginationRequest<ValidationFilter_2> = {};
  if (filter) params.filter = filter;

  return axios
    .post<any[]>(`${paramRangeRoute}calculate-hourly-param`, {
      params: { ...params },
    })
    .then(responseHandlerDefault);
};

// Calcular estadísticas por día de la semana PARAM
export const calculateWeeklyDataParam = (
  filter: ValidationFilter_2
): Promise<
  Record<
    string,
    Array<{
      id: number;
      nameRange: string;
      count: number;
      beginningRange: number;
      endRange: number;
      percentage: number;
    }>
  >
> => {
  const params: PaginationRequest<ValidationFilter_2> = {};
  if (filter) params.filter = filter;

  return axios
    .post(`${paramRangeRoute}/calculate-weekly-param`, {
      params: { ...params },
    })
    .then(responseHandlerDefault);
};

// Calcular % de estimaciones por rangos
export const calculateTmoaPercentagesRanges = (
  filter: ValidationFilter_2
): Promise<TablePercentageRow[]> => {
  const params: PaginationRequest<ValidationFilter_2> = {};

  if (filter) {
    params.filter = filter;
  }
  return axios
    .post<any[]>(`${paramRangeRoute}calculate-percentages`, {
      params: { ...params },
    })
    .then(responseHandlerDefault);
};
